import { useEffect, useMemo } from 'react';
import { useLazyGetAssetsAllocationsQuery, useUpdateAssetsAllocationsMutation } from '@/store/api/userApi';
import { useParams } from 'react-router-dom';
import { filterByFields } from '@/components/pages/SettingsPage/MainContent/utils';
import { useAppFilters, useToast } from '@/hooks';

export const useAssetsAllocation = () => {
  const { toast } = useToast();
  const { search: searchValue } = useAppFilters();
  const { userId } = useParams<{ userId: string }>();
  const [fetch, { data, isLoading, isFetching, isError }] = useLazyGetAssetsAllocationsQuery();
  const [update] = useUpdateAssetsAllocationsMutation();

  const updateAssetsAllocation = async (payload: any) => {
    try {
      await update(payload).unwrap();

      toast({
        variant: 'success',
        title: 'Success',
        description: 'Assets allocation preferences have been updated',
      });
    } catch (error: any) {
      toast({
        variant: 'destructive',
        title: 'Error',
        description: `Failed to update assets allocation preferences`,
      });
    }
  };

  const tableData = useMemo(() => {
    if (!data) return [];
    if (!searchValue) return data;

    const fieldsToSearch = ['asset_ui_name'];
    return filterByFields(data, searchValue, fieldsToSearch);
  }, [searchValue, data]);

  useEffect(() => {
    fetch({ userId }, true);
  }, [userId]);

  return {
    data: tableData,
    isLoading,
    isFetching,
    isError,
    updateAssetsAllocation,
  };
};
